export var getMultilingualQueryParam = function (multilingual) {
    if (multilingual === null || multilingual === void 0 ? void 0 : multilingual.currentLanguage) {
        var locale = multilingual.siteLanguages.find(function (lang) { return lang.languageCode === multilingual.currentLanguage; });
        if (!locale.isPrimaryLanguage && locale.resolutionMethod === 'QueryParam') {
            return "?lang=" + locale.languageCode;
        }
    }
    return '';
};
